<template>
    <v-container class="content-background" fluid style="background-color: #ffffff;">
        <div v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
          <div style="min-width:100%;width:100%;" class="d-flex align-center flex-column">
                    <div style="width:100%;text-align:left;text-decoration: none;">
                    </div>
            <span style="width:100%;">
                <NavBar_InDel></NavBar_InDel>

                <v-container justify="center" fill-height fluid>
                    <v-row>
                        <div style="width:100%;" v-html="this.$store.getters.getProcessState('load-results')"></div>
                    </v-row>
                   <v-row style="text-align: center;margin-bottom:0;padding-bottom:0;">
                        <v-col cols="12" md="12" lg="4" xl="4" style="text-align:center;">
                            <div class="content-box-toolbar-div">
                                        <v-toolbar class="rounded-lg elevation-2" dark color="#f5f5f5" style="padding:0;text-align:left;height:35px;" density="compact">
                                             <v-toolbar-title style="font-size:14px;font-weight:300;padding:0;margin:0;margin-left:10px;">
                                                   Gene
                                             </v-toolbar-title>
                                        </v-toolbar>
                            </div>
                            <v-card class="elevation-2 content-box"  style="padding-left:10px;padding-right:10px;">
                                <v-table>
                                    <tr>
                                        <td>Type</td>
                                        <td>{{ item.variant_data.type }}</td>
                                    </tr>
                                    <tr v-if="'gencode_genomic' in item">
                                            <td>Gene</td>
                                            <td v-if="'gene' in item.gencode_genomic">
                                                {{ item.gencode_genomic.gene[0].gene_name }}
                                            </td>
                                    </tr>
                                    <tr v-if="'gencode_genomic' in item">
                                            <td>Gene ID</td>
                                            <td v-if="'gene' in item.gencode_genomic">
                                                {{ item.gencode_genomic.gene[0].gene_id }}
                                            </td>
                                    </tr>
                                    <tr v-if="'gencode_genomic' in item">
                                            <td>HGNC ID</td>
                                            <td v-if="'gene' in item.gencode_genomic">
                                                {{ item.gencode_genomic.gene[0].hgnc_id }}
                                            </td>
                                    </tr>
                                    <tr v-if="'gencode_genomic' in item">
                                            <td>Gene type</td>
                                            <td v-if="'gene' in item.gencode_genomic">
                                                {{ item.gencode_genomic.gene[0].gene_type }}
                                            </td>
                                    </tr>
                                    <tr v-if="'gencode_genomic' in item">
                                            <td>Gene Start/End</td>
                                            <td v-if="'gene' in item.gencode_genomic">
                                                {{ item.gencode_genomic.gene[0].seqname }}
                                                {{ item.gencode_genomic.gene[0].start_pos }}
                                                -
                                                {{ item.gencode_genomic.gene[0].end_pos }}
                                            </td>
                                    </tr>
                                </v-table>
                            </v-card>
                        </v-col>
                   </v-row>
                </v-container>


            </span>
          </div>
        </div>

        <div style="padding:20px;">
            <div id="igvContainer" ref="igvContainer">
            </div>
        </div>

    </v-container>
</template>
<script>
import NavBar_InDel from '@/components/navbars/NavBar_InDel';
import variant_annotation from "@/methods/variant_annotation";
import active_variants from "@/methods/active_variants";
import axios from 'axios';
import igv_browser from "@/methods/igv_browser";
import useTooltip from '@/methods/tooltip.js';

export default {
    name: "upload-data-variant-interpretation",
    data: function() {
        return {
            variantlisttext: '',
            flask_greeting: '',
            message: '',
            isLoading: false,
            fullPage: true,
            civic_summary: '',
            vcfContent: '',
            active_chrom : '',
            active_pos_start: 0,
            active_pos_end: 0,
            active_ref: '',
            active_alt: '',
            blosum_val: 0,
            blosum_color: '#ffffff',
            aa_dc: {
                "A": "Alanine",
                "R": "Arginine",
                "N": "Asparagine",
                "D": "Aspartic acid",
                "C": "Cysteine",
                "E": "Glutamic acid",
                "Q": "Glutamine",
                "G": "Glycine",
                "H": "Histidine",
                "I": "Isoleucine",
                "L": "Leucine",
                "K": "Lysine",
                "M": "Methionine",
                "F": "Phenylalanine",
                "P": "Proline",
                "S": "Serine",
                "T": "Threonine",
                "W": "Tryptophan",
                "Y": "Tyrosine",
                "V": "Valine",
                "U": "Selenocysteine",
                "O": "Pyrrolysine"
            }
        }
    },
    async mounted() {

    },
    created: async function() {
        this.$store.dispatch('setProcessState', [  "load-results",'<table><tr><td><div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div></td></tr><tr><td>Loading...</td></tr></table>' ] )
        await active_variants.loadActiveBiomarkerInDel(this.$route.params.id)
        this.$store.dispatch('setProcessState', [  "load-results",'' ] )

        if (this.$store.getters.backRef == null) {
            this.$store.dispatch('setBackRef', '/upload')
        }

        await this.initSeqviz()

        let activeBiomarker = this.$store.getters.getActiveBiomarker
        activeBiomarker = activeBiomarker[Object.keys(activeBiomarker)[0]]

        if (activeBiomarker != undefined) {
            if ("variant_data" in activeBiomarker) {
                let chrom = activeBiomarker["variant_data"]["CHROM"]
                let pos = activeBiomarker["variant_data"]["POS"]
                let ref = activeBiomarker["variant_data"]["REF"]
                let alt = activeBiomarker["variant_data"]["ALT"]

                await this.loadData(chrom,pos,ref,alt)
                await igv_browser.initializeIGVBrowser(this.$refs.igvContainer,this.active_chrom,this.vcfContent)


                if ("blosum62" in activeBiomarker["variant_data"]) {
                    this.blosum_val=this.getBlosumPercentage(activeBiomarker["variant_data"]["blosum62"])
                    this.blosum_color=this.getBlosumColor(activeBiomarker["variant_data"]["blosum62"])
                }
            }
        }

    },
    computed: {
    },
    methods: {
        showTooltip(element_id, tooltip_id, tooltip_title = undefined) {
            useTooltip.fireTooltipEvent(element_id, tooltip_id, tooltip_title);
        },
        getBlosumPercentage(val) {
            switch (val) {
                case -4:
                    return 100
                case -3:
                    return 90
                case -2:
                    return 80
                case -1:
                    return 70
                case 0:
                    return 50
                case 1:
                    return 40
                case 2:
                    return 30
                case 3:
                    return 20
                case 4:
                    return 10
            }
            return 0
        },
        getBlosumColor(val) {
            switch (val) {
                case -3:
                    return "#b50000"
            }
            switch (val) {
                case -4:
                    return "#f20000"
                case -3:
                    return "#e74f4f"
                case -2:
                    return "#e86a6a"
                case -1:
                    return "#e79898"
                case 0:
                    return "#dc8e1b"
                case 1:
                    return "#b8ea8a"
                case 2:
                    return "#9ddc63"
                case 3:
                    return "#88d93d"
                case 4:
                    return "#69bd1c"
            }
            return "#69bd1c"
        },
        getRefAA(ref_aa) {
            let src = ""
            switch(ref_aa) {
                case 'A':
                    src = 'as_ala.gif'
                    break
                case 'R':
                    src = 'as_arg.gif'
                    break
                case 'N':
                    src = 'as_asn.gif'
                    break
                case 'D':
                    src = 'as_asp.gif'
                    break
                case 'C':
                    src = 'as_cys.gif'
                    break
                case 'E':
                    src = 'as_glu.gif'
                    break
                case 'Q':
                    src = 'as_gln.gif'
                    break
                case 'G':
                    src = 'as_gly.gif'
                    break
                case 'H':
                    src = 'as_his.gif'
                    break
                case 'I':
                    src = 'as_ile.gif'
                    break
                case 'L':
                    src = 'as_leu.gif'
                    break
                case 'K':
                    src = 'as_lys.gif'
                    break
                case 'M':
                    src = 'as_met.gif'
                    break
                case 'F':
                    src = 'as_phe.gif'
                    break
                case 'P':
                    src = 'as_pro.gif'
                    break
                case 'S':
                    src = 'as_ser.gif'
                    break
                case 'T':
                    src = 'as_thr.gif'
                    break
                case 'W':
                    src = 'as_trp.gif'
                    break
                case 'Y':
                    src = 'as_tyr.gif'
                    break
                case 'V':
                    src = 'as_val.gif'
                    break
                case 'U':
                    src = 'as_sec.gif'
                    break
                case 'O':
                    src = 'as_pyl.gif'
            }
            //alert(ref_aa + src)
            return require('./../../assets/amino_acids/'+src)
        },
        rerender_bars() {
            //this.revel_key += 1
            //this.loftool_key += 1
            //this.vuspredict_key += 1
            //this.mvp_key += 1
        },
        ltrim(x, characters) {
          var start = 0;
          while (characters.indexOf(x[start]) >= 0) {
            start += 1;
          }
          var end = x.length - 1;
          return x.substr(start);
        },
        rtrim(x, characters) {
          var start = 0;
          var end = x.length - 1;
          while (characters.indexOf(x[end]) >= 0) {
            end -= 1;
          }
          return x.substr(0, end + 1);
        },
        pos_formatted(pos_start) {
                    var splitString = String(pos_start).split("");

                    var reverseArray = splitString.reverse();
                    let reverseArraytoStr = ''
                    for (let i=0; i<reverseArray.length; i +=1) {
                        reverseArraytoStr += reverseArray[i]
                    }
                    //alert(reverseArraytoStr)
                    const result = reverseArraytoStr.match(/.{1,3}/g) || [];

                    let result_str = ''
                    for (let i=0; i<result.length; i +=1) {
                        result_str += result[i] + ','
                    }
                    result_str = this.rtrim(result_str,',')
                    //alert(result_str)

                    let result_arr = result_str.split("").reverse()
                    let result_splitted = ''
                    for (let i=0; i<result_arr.length; i +=1) {
                        result_splitted += result_arr[i]
                    }
                    result_splitted = this.ltrim(result_splitted,',')
                    return result_splitted
        },
        /**
        * Returns the content of the given file `path` as a string.
        *
        * @param {String} path
        *
        * @returns {String}
        */
        async content(chrom,pos,ref,alt) {
                let pos_start = parseInt(pos) -20
                let pos_end = parseInt(pos) + 20
                let cont = '##fileformat=VCFv4.1\nchr' + chrom + '\t' + pos + '\t.\t'+ ref +'\t' + alt + '\t.\t.\t.\n'

              let date = new Date(2023, 1, 1)
              this.vcfContent = new File([cont],'sample.vcf', {type: "text/plain", lastModified: date})

                    // pos_start
                    let result_start = this.pos_formatted(pos_start)
                    let result_end = this.pos_formatted(pos_end)
                    //alert(pos_start + ":" + result_start)
                    //alert(pos_end + ":" + result_end)

                this.active_chrom = 'chr' + chrom + ':' + result_start + "-" + result_end
                this.active_pos_start = pos_start
                this.active_pos_end = pos_end
                this.active_ref = ref
                this.active_alt = alt

        },
        async loadData(chrom,pos,ref,alt) {

            let path = ''
            this.content(chrom,pos,ref,alt)

            /*const igvBrowser = this.$refs.igvBrowser;
            igvBrowser.loadTrack({
                type: 'alignment',
                format: 'vcf',
                name: 'Data',
                url: file.fileData
            })*/
        },
        async initSeqviz() {
            //applyReactInVue(SeqViz)
            //this.Basic.render()

            /* seqviz("root", {
               name: "L09136",
               seq: "tcgcgcgtttcggtgatgacggtgaaaacctctgacacatgca",
               style: { height: "100vh", width: "100vw" },
             })
             .render();*/

            /*const element = document.getElementById("seqvizcontent");
            const props = { name:"test", seq:"tcgcgcgtttcggtgatgacggtgaaaacctctgacacatgca",style: { height: "100vh", width: "100vw" } }
            const viewer = seqviz.Viewer(element, props);
            // Render the viewer to the DOM at the node passed in $element`.
            viewer.render();
            // To later update the viewer's configuration and re-renders.
            viewer.setState(props);
            // To render the viewer, eg for server-side rendering, and returns it as an HTML string.
            viewer.renderToString();*/
        }
    },
    components: {
        NavBar_InDel,
    }
}

</script>
<style>
.bground-main {
    background-color: #ffffff;
}
.content-box {
    margin-left:0px;
    text-align: left;
    padding:20px;
}
.content-box-title {
}
.content-box-header-space {
  height:0px;
}
.content-box-toolbar-div {
  margin:auto;width:90%;position:relative; top:20px;z-index:10;
  margin-bottom:0;
  margin-top:0;
}
</style>
